/**
 * Price Formatter Module
 * Formats prices the same way as wc_price() in PHP, using the WooCommerce settings passed from WP
 */
export class PriceFormatter {
  constructor(options) {
    this.config = options
  }

  format(amount) {
    const { decimals, decimalSep, thousandSep, trimZeros } = this.config
    const [integer, fraction = ''] = Math.abs(amount).toFixed(decimals).split('.')
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep)
    const sign = amount < 0 ? '-' : ''

    if (!fraction || (trimZeros && /^0+$/.test(fraction))) {
      return `${sign}${grouped} kr`
    }

    return `${sign}${grouped}${decimalSep}${fraction} kr`
  }

  get suffix() {
    return this.config.suffix
  }
}
